import { useQuery } from "@tanstack/react-query";
import { Empty, Flex, Radio, Typography } from "antd";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { getSchemas } from "../actions/acc_actions";
import InsightsSummary from "../components/InsightsSummary";
import ContentLayout from "../components/layout/ContentLayout";

const { Title, Text } = Typography;

export default function Home() {
  const { t } = useTranslation();
  const name = useSelector((state) => state.account.name);
  const businessUrn = useSelector((state) => state.account.businessUrn);

  const [selectedSchema, setSelectedSchema] = useState();

  const { isLoading, data } = useQuery({
    queryKey: ["schemas", businessUrn],
    queryFn: () => getSchemas(businessUrn, "STAMP_CARD"),
    enabled: !!businessUrn,
    staleTime: 5 * 60 * 1000,
  });

  const schemas = data?.data?.body || [];

  const options = useMemo(() => {
    return schemas.map((schema) => ({
      label: schema.name,
      value: schema.slug,
    }));
  }, [schemas]);

  // auto-select first schema
  useEffect(() => {
    if (!selectedSchema && options.length > 0) {
      setSelectedSchema(options[0].value);
    }
  }, [options, selectedSchema]);

  const noSchemas = !isLoading && schemas.length === 0;

  return (
    <ContentLayout
      header={
        <Flex vertical gap={20}>
          <Title level={2}>
            {t("welcome")} <span>{name}</span>
          </Title>

          {/* Schema selector */}
          {!noSchemas && (
            <Flex align="center" gap={16} wrap="wrap">
              <Text strong>{t("your_insights_for")}:</Text>

              <Radio.Group
                options={options}
                value={selectedSchema}
                onChange={(e) => setSelectedSchema(e.target.value)}
                optionType="button"
                buttonStyle="solid"
              />
            </Flex>
          )}

          {/* Summary */}
          {!noSchemas && selectedSchema && (
            <InsightsSummary selectedSchema={selectedSchema} />
          )}
        </Flex>
      }
    >
      <div className="home">
        {noSchemas ? (
          <Empty description={t("you_must_create_stampcard_first")} />
        ) : (
          <>
            <div className="home-card">
              <div className="home-card-content">
                <h4>{t("campaigns")}</h4>
                <Link to="/campaigns" className="btn primary home-btn">
                  {t("send_rewards_to_customers")}
                </Link>
              </div>
            </div>

            <div className="home-card">
              <div className="home-card-content">
                <h4>{t("data_and_insights")}</h4>
                <Link to="/insights" className="btn primary home-btn">
                  {t("view_insights")}
                </Link>
              </div>
            </div>

            <div className="home-card">
              <div className="home-card-content">
                <h4>{t("reward_customers_magic_codes")}</h4>
                <Link to="/magic-codes" className="btn primary home-btn">
                  {t("setup_magic_code")}
                </Link>
              </div>
            </div>
          </>
        )}
      </div>
    </ContentLayout>
  );
}
